export const updateEvent = (id) => async (dispatch) => {

};

export const eventAdded = (id) => async (dispatch) => {

};

export const useOpenCalendarEvent = () => {

};

export const useAddCalendarEvent = () => {

};


export const getAuthorization = async () => {

};

export const updateEvents = () => async (dispatch, getState) => {

};

export const useUpdateEvents = () => {

};

export const toggleCalendar = (id) => (dispatch) => {

};
